// src/components/admin/modal/Modal.jsx
import React, { useEffect } from "react";
import { X } from "lucide-react";
import "../../../assets/css/admin/modal/ProductModel.css";

const ProductModal = ({
  isOpen,
  onClose,
  title,
  children,
  size = "medium", // small | medium | large
}) => {
  // Close on ESC
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape" && isOpen) onClose();
    };
    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [isOpen, onClose]);

  // Lock body scroll
  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      className="adm-modal-overlay"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label={title}
    >
      <div
        className={`adm-modal-container adm-modal-${size}`}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="adm-modal-header">
          <h2 className="adm-modal-title">{title}</h2>
          <button
            className="adm-modal-close-btn"
            onClick={onClose}
            aria-label="Close modal"
          >
            <X size={18} />
          </button>
        </div>

        {/* Body */}
        <div className="adm-modal-body">{children}</div>
      </div>
    </div>
  );
};

export default ProductModal;
